import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GungTabChangeEvent } from 'gung-common';
import { GungSettingsBaseViewComponent } from '../../gung-settings-base-view/gung-settings-base-view.component';

const CONFIGURATION_TAB = 'configuration';
const CART_TRANSFERS_TAB = 'cart-transfers';
const ORDER_REQUESTS_TAB = 'order-requests';
const TAB_IDS = [CONFIGURATION_TAB, CART_TRANSFERS_TAB, ORDER_REQUESTS_TAB];

// This is the query param for this tabset. It is separate from the settings menu's own `tab` param.
const TAB_QUERY_PARAM = 'punchoutTab';

/**
 * Shell for the punchout settings area. Owns the heading and the tabset. Each tab's content lives
 * in its own component.
 *
 * The tabset runs with destroyOnHide false. This keeps a tab's content mounted after the admin
 * switches away from it, so switching back does not re-fetch the audit list. It does not defer
 * the first fetch: ngbNav mounts all three tabs' content on load, so all three tabs fetch data
 * immediately, not only the active one.
 */
@Component({
  selector: 'lib-gung-settings-punchout',
  templateUrl: './gung-settings-punchout.component.html',
  styleUrl: './gung-settings-punchout.component.scss',
  standalone: false
})
export class GungSettingsPunchoutComponent extends GungSettingsBaseViewComponent implements OnInit {
  protected router = inject(Router);
  protected activatedRoute = inject(ActivatedRoute);

  activeTabId = CONFIGURATION_TAB;

  ngOnInit(): void {
    this.activeTabId = this.getInitialTabId();
  }

  onTabChange(event: GungTabChangeEvent): void {
    this.activeTabId = event.nextId;
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { [TAB_QUERY_PARAM]: event.nextId },
      queryParamsHandling: 'merge'
    });
  }

  private getInitialTabId(): string {
    const snapshot = this.activatedRoute?.snapshot;
    // The settings menu renders this component in an outlet. The query param may be on this
    // route's snapshot or on the parent route's snapshot, depending on how the app defines the route.
    const param = snapshot?.queryParams?.[TAB_QUERY_PARAM] ?? snapshot?.parent?.queryParams?.[TAB_QUERY_PARAM];
    return TAB_IDS.includes(param) ? param : CONFIGURATION_TAB;
  }
}
